import { useEffect, useState } from 'react'
import { Button } from '~/shadcn/ui/button/button'
import { Spinner } from '~/shadcn/ui/spinner'
import { FieldError } from '~/shadcn/ui/field'
import { useDebounce } from '~/@lib/utils/function.utils'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'
import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'
import { usePublicAmbassadorInfo } from '~/@biz_ambassador/claim/usePublicAmbassadorInfo'
import { useAmbassadorCode } from '~/@biz_ambassador/code/useAmbassadorCode'
import { useMyAmbassador } from '../useMyAmbassador'
import { MyAmbassadorInviteBannerCollapse } from './MyAmbassadorInviteBannerCollapse'

export function ClaimAmbassadorForm() {
  const { ambassadorCode: storedCode } = useAmbassadorCode()
  const { debounce } = useDebounce(1000)
  const [code, setCode] = useState(storedCode ?? '')
  const [debouncedCode, setDebouncedCode] = useState(storedCode ?? '')
  const { data: ambassadorInfo } = usePublicAmbassadorInfo(
    debouncedCode.trim() || undefined
  )
  const { claimMutation } = useMyAmbassador({ enabled: false })

  function handleCodeChange(value: string) {
    setCode(value)
    debounce(() => setDebouncedCode(value))
    // Drop the previous failed-claim error as soon as the code is edited.
    if (claimMutation.isError) claimMutation.reset()
  }

  // Keep the last resolved info so the preview can animate out (not just snap).
  const [previewInfo, setPreviewInfo] = useState(ambassadorInfo)
  useEffect(() => {
    if (ambassadorInfo) setPreviewInfo(ambassadorInfo)
  }, [ambassadorInfo])

  return (
    <div className="flex flex-col">
      <MyAmbassadorInviteBannerCollapse
        isOpen={!!ambassadorInfo}
        info={previewInfo}
      />

      <div className="flex flex-col gap-1">
        <div className="flex flex-row gap-1">
          <label className="text-sm font-medium text-foreground">Kód</label>
          <TextTooltip text="Kód si môžete vyžiadať od vášho ambasádora." />
        </div>

        <div className="flex flex-row items-center gap-3">
          <input
            type="text"
            value={code}
            onChange={(e) => handleCodeChange(e.target.value)}
            className="w-[284px] h-[50px] px-4 border border-muted-foreground rounded"
          />
          <Button
            variant="accent"
            size="medium"
            disabled={!code.trim() || claimMutation.isPending}
            onClick={() => claimMutation.mutate({ ambassadorCode: code })}>
            {claimMutation.isPending && <Spinner className="size-5" />}
            Aktivovať
          </Button>
        </div>

        {claimMutation.isError && (
          <FieldError>
            {getApiErrorMessage(
              claimMutation.error,
              'Kód sa nepodarilo aktivovať.'
            )}
          </FieldError>
        )}
      </div>
    </div>
  )
}
